import type { ComponentProps, FC, ReactElement } from 'react';

import { LeadGroups } from 'constants/leadGroups';

import { EmptyText, EmptyTextAccent, SmallCardContainer } from './styled';

type IEmptyCardProps = ComponentProps<typeof SmallCardContainer> & {
    type: LeadGroups;
};

const RecommendedEmptyText: FC = () => {
    return (
        <EmptyText>
            You currently don&apos;t have any{' '}
            <EmptyTextAccent type={LeadGroups.RECOMMENDED}>
                {' '}
                recommended leads
            </EmptyTextAccent>
            . Please check back later.
        </EmptyText>
    );
};

const ContactedEmptyText: FC = () => {
    return (
        <EmptyText>
            Contact property Decision Makers and status will change to
            <EmptyTextAccent type={LeadGroups.CONTACTED}>
                {' '}
                contacted
            </EmptyTextAccent>
            .
        </EmptyText>
    );
};

const ActiveConversationEmptyText: FC = () => {
    return (
        <EmptyText>
            Follow up on the
            <EmptyTextAccent type={LeadGroups.ACTIVE_CONVERSATION}>
                {' '}
                active conversations
            </EmptyTextAccent>{' '}
            with Decision Makers to list properties faster.
        </EmptyText>
    );
};

const emptyTextMap: { [key in LeadGroups]?: ReactElement } = {
    [LeadGroups.RECOMMENDED]: <RecommendedEmptyText />,
    [LeadGroups.CONTACTED]: <ContactedEmptyText />,
    [LeadGroups.ACTIVE_CONVERSATION]: <ActiveConversationEmptyText />,
};

export const EmptyCard: FC<IEmptyCardProps> = ({ type, ...props }) => {
    return (
        <SmallCardContainer {...props}>{emptyTextMap[type]}</SmallCardContainer>
    );
};
